/* Dear Stranger theme JS — editor-safe, re-initializes on Shopify section reloads */
(function () {
  var DESIGN_MODE = document.body && document.body.classList.contains('design-mode');

  function fillCountdown() {
    var I = window.DS_I18N || {};
    var loc = I.locale || document.documentElement.lang || 'en';
    var now = new Date();
    var cutoff = new Date(now.getFullYear(), now.getMonth(), 27, 23, 59, 59);
    if (now > cutoff) { cutoff = new Date(now.getFullYear(), now.getMonth() + 1, 27, 23, 59, 59); }
    var letterDate = new Date(cutoff.getFullYear(), cutoff.getMonth() + 1, 1);
    var monthName, dateStr;
    try {
      monthName = new Intl.DateTimeFormat(loc, { month: 'long' }).format(letterDate);
      dateStr = new Intl.DateTimeFormat(loc, { month: 'long', day: 'numeric' }).format(cutoff);
    } catch (e) {
      monthName = String(letterDate.getMonth() + 1);
      dateStr = (cutoff.getMonth() + 1) + '/27';
    }
    var daysLeft = Math.max(0, Math.ceil((cutoff - now) / 86400000));
    var daysTxt = daysLeft <= 1 ? (I.last || 'last day to join')
      : (I.days || '{n} days left').replace('{n}', daysLeft);
    var decBox = document.createElement('textarea');
    function dec(str) { decBox.innerHTML = str || ''; return decBox.value; }
    function render(tpl) {
      return dec(tpl).replace('{date}', dateStr).replace('{month}', monthName).replace('{days}', daysTxt);
    }
    var tplEls = document.querySelectorAll('.deadline-text');
    for (var i = 0; i < tplEls.length; i++) {
      tplEls[i].textContent = render(I[tplEls[i].getAttribute('data-tpl')]);
    }
    /* localized date inside settings-driven sentences (final CTA lede) */
    var set = function (cls, txt) {
      var els = document.querySelectorAll('.' + cls);
      for (var k = 0; k < els.length; k++) { els[k].textContent = txt; }
    };
    set('cutoff-date', dateStr);
    set('letter-month', monthName);
    set('days-left', daysTxt);
  }

  function initIntro() {
    var intro = document.getElementById('dsIntro');
    if (!intro) return;
    var typeEl = document.getElementById('dsType');
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var seen = false;
    try { seen = sessionStorage.getItem('dsIntroSeen') === '1'; } catch (e) {}
    var kill = function () {
      intro.classList.add('done');
      try { sessionStorage.setItem('dsIntroSeen', '1'); } catch (e) {}
      setTimeout(function () { if (intro.parentNode) { intro.parentNode.removeChild(intro); } }, 750);
    };
    if (DESIGN_MODE || reduced || seen || !typeEl) {
      if (intro.parentNode) { intro.parentNode.removeChild(intro); }
      return;
    }
    var msg = 'Dear stranger,';
    var i = 0;
    var t = setInterval(function () {
      i++;
      typeEl.textContent = msg.slice(0, i);
      if (i >= msg.length) { clearInterval(t); setTimeout(kill, 650); }
    }, 70);
    intro.addEventListener('click', function () { clearInterval(t); kill(); });
    setTimeout(function () { clearInterval(t); kill(); }, 3500);
  }

  function initReveals() {
    /* Never hide content in the editor, without IntersectionObserver, or with reduced motion */
    if (DESIGN_MODE || !('IntersectionObserver' in window)) return;
    document.body.classList.add('js-rv');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    var rvs = document.querySelectorAll('.rv:not(.in)');
    for (var i = 0; i < rvs.length; i++) {
      /* anything already on screen reveals immediately; observer handles the rest */
      io.observe(rvs[i]);
    }
  }

  var listenersBound = false;
  function bindScrollListeners() {
    if (listenersBound) return;
    listenersBound = true;
    window.addEventListener('scroll', function () {
      var hdr = document.getElementById('dsHdr');
      if (hdr) { hdr.classList.toggle('scrolled', window.scrollY > 8); }
      var sticky = document.getElementById('dsSticky');
      var hero = document.querySelector('.hero');
      var finalSec = document.querySelector('.final');
      if (sticky && hero) {
        var heroBottom = hero.getBoundingClientRect().bottom;
        var finalTop = finalSec ? finalSec.getBoundingClientRect().top : Infinity;
        sticky.classList.toggle('show', heroBottom < 0 && finalTop > window.innerHeight * 0.6);
      }
    }, { passive: true });
  }


  /* ---- one-click join: add subscription to cart, go straight to checkout ---- */
  var joinBound = false;
  function initJoin() {
    if (joinBound) return;
    joinBound = true;
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest('.js-join');
      if (!a || !window.DS_JOIN || !window.DS_JOIN.variant) return;
      ev.preventDefault();
      var item = { id: window.DS_JOIN.variant, quantity: 1 };
      if (window.DS_JOIN.plan) { item.selling_plan = window.DS_JOIN.plan; }
      a.classList.add('is-busy');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) {
        if (!r.ok) { throw new Error('cart'); }
        window.location.href = '/checkout';
      }).catch(function () {
        window.location.href = a.getAttribute('href') || '/cart';
      });
    });
  }

  function init() {
    DESIGN_MODE = document.body.classList.contains('design-mode');
    fillCountdown();
    initIntro();
    initReveals();
    bindScrollListeners();
    initJoin();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor re-renders sections — re-run setup every time it does */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', fillCountdown);
  document.addEventListener('shopify:block:select', fillCountdown);
})();
